import React, { useContext, useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getAboutUsDetails, getSaluteDetails, getTeamDetails, getHomeDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import Team from "../Teams/Team";
import AboutContent from "./AboutContent";
import Activities from "./Activities";
import Highlights from "./Highlights";
import About from "../Home/About";
import ScaleEvent from "./ScaleEvent";
import RofdaMap from "../RofdaMap";

const AboutUs = () => {
  const { appState, dispatch } = useContext(AppContext);
  const { aboutUs, aboutUsLoader, salute, saluteLoader } = appState;
  const { ourTeam, ourTeamLoader } = appState;
  const myRef = useRef(null);
  useEffect(() => {
    getAboutUsDetails(appState, dispatch)
    getTeamDetails(appState, dispatch)
    getSaluteDetails(appState, dispatch)
    getHomeDetails(appState, dispatch)
  }, [])

  return (
    <>
      {
        aboutUsLoader ?
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
          :
          Object.keys(aboutUs).length &&
          <>
            <Breadcrumb
              pageName={aboutUs.header_services_section.title || "about us"}
              pageTitle={aboutUs.header_services_section.title || "about us"}
              id={`#${aboutUs.header_services_section.title}`}
              image={aboutUs.header_services_section.banner_image}
              myRef={myRef}
            />
            <div ref={myRef}>
              {/* <AboutContent about={aboutUs} /> */}
              <About about={aboutUs.about_section} />
              <RofdaMap />
              <Highlights service={aboutUs.services_section} />
              {/* <Activities activity={aboutUs.activites_section} /> */}
             <ScaleEvent activity={aboutUs["2027_rofda_scale_events_program_section"]} />
              {/* <>
                {
                  saluteLoader ?
                    <div className='home-spinner'>
                      <ClipLoader color={"#2A5350"} loading={true} size={60} />
                    </div>
                    :
                    Object.keys(salute).length &&
                    <>
                      <div ref={myRef}>
                        {
                          salute.salutes_section && salute.salutes_section.length &&
                          salute.salutes_section
                            .filter(s => ["ROFDA Services & Programs","About Page Client Counts", "Our Services"].includes(s.main_title)) // about us page image count remove - for view remove s ( Counts)
                            .map(section => {
                              return (
                                section.services_list.length > 0 &&
                                <>
                                  {
                                    <div className="portfolio-section mb-50" id="project" data-aos="fade-up">
                                      <div className="container">
                                        <div className="section-title2 primary3 text-start">
                                          <span>{section.main_title}</span>
                                            <h2>{section.highlist_title}</h2>
                                          <p className="para">
                                            {section.sub_title}
                                          </p>
                                        </div>
                                        <div className="row position-relative g-4">
                                          {section.services_list.map((item) => {
                                            return (
                                              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={item.id}>
                                                <div
                                                  className="portfolio-item1 glass-effect"
                                                  data-wow-duration="1.5s"
                                                  data-wow-delay="0.2s"
                                                >
                                                  <div className="portfolio-img ">
                                                    {
                                                      item.icon_image &&
                                                      <img alt="portfolio-img" src={item.icon_image} className="img-fluid" />
                                                    }
                                                  </div>
                                                  <div className="portfolio-content">
                                                    <span>{section.highlist_title}</span>
                                                    <h4 className="m-0">
                                                      <p>{item.title}</p>
                                                    </h4>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </>
                              )
                            })
                        }
                      </div>
                    </>
                }
              </> */}


            </div>
          </>
      }
      {/* {
        ourTeamLoader ?
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
          :
          Object.keys(ourTeam).length &&
          <div className="team-section2 mb-50">
            <div className="container">
              <div className="row justify-content-center">
                  <div className="section-title2 primary3">
                    <span>{ourTeam.header_team_section.title}</span>
                  </div>
              </div>
              {
                ourTeam.team_section.map(section => {
                  return <Team team={section} />
                })
              }
            </div>
          </div>
      } */}
    </>
  );
}

export default AboutUs;